// image data for men
import img1 from "../assets/men/img1.png"
import img2 from "../assets/men/img2.png"
import img3 from "../assets/men/img3.png"
import img4 from "../assets/men/img4.png"
import img5 from "../assets/men/img5.png"
import img6 from "../assets/men/img6.png"
import img7 from "../assets/men/img7.png"
import img8 from "../assets/men/img8.png"
import img9 from "../assets/men/img9.png"
import img37 from "../assets/men/img10.png"
import img38 from "../assets/men/img11.png"
import img39 from "../assets/men/img12.png"
import img40 from "../assets/men/img13.png"
import img41 from "../assets/men/img14.png"
import img42 from "../assets/men/img15.png"
import img43 from "../assets/men/img16.png"
import img44 from "../assets/men/img17.png"
import img45 from "../assets/men/img18.png"

// image data for shoes
import img10 from "../assets/img10.webp"
import img11 from "../assets/img11.webp"
import img12 from "../assets/img12.webp"
import img13 from "../assets/img13.webp"
import img14 from "../assets/img14.jpg"
import img15 from "../assets/img15.webp"
import img16 from "../assets/img16.webp"
import img17 from "../assets/img17.jfif"
import img18 from "../assets/img18.webp"
import img79 from "../assets/img24.png"


// image data for kids
import img19 from "../assets/kids/img1.png"
import img20 from "../assets/kids/img2.png"
import img21 from "../assets/kids/img3.png"
import img22 from "../assets/kids/img4.png"
import img23 from "../assets/kids/img5.png"
import img24 from "../assets/kids/img6.png"
import img25 from "../assets/kids/img7.png"
import img26 from "../assets/kids/img8.png"
import img27 from "../assets/kids/img9.png"
import img46 from "../assets/kids/img10.png"
import img47 from "../assets/kids/img11.png"
import img48 from "../assets/kids/img12.png"
import img49 from "../assets/kids/img13.png"
import img50 from "../assets/kids/img14.png"
import img51 from "../assets/kids/img15.png"
import img52 from "../assets/kids/img16.png"
import img53 from "../assets/kids/img17.png"
import img54 from "../assets/kids/img18.png"
import img77 from "../assets/kids/img19.jpg"
import img78 from "../assets/kids/img20.jpg"

// image data for women
import img28 from "../assets/women/img1.png"
import img29 from "../assets/women/img2.png"
import img30 from "../assets/women/img3.png"
import img31 from "../assets/women/img4.png"
import img32 from "../assets/women/img5.png"
import img33 from "../assets/women/img6.png"
import img34 from "../assets/women/img7.png"
import img35 from "../assets/women/img8.png"
import img36 from "../assets/women/img9.png"
import img65 from "../assets/women/img10.png"
import img66 from "../assets/women/img11.png"
import img67 from "../assets/women/img12.png"
import img68 from "../assets/women/img13.png"
import img69 from "../assets/women/img14.png"
import img70 from "../assets/women/img15.png"
import img71 from "../assets/women/img16.png"
import img72 from "../assets/women/img17.png"
import img73 from "../assets/women/img18.png"
import img75 from "../assets/women/img69.png"
import img76 from "../assets/women/img68.png"

//electronics
import img74 from "../assets/electronics/sales10.jpg"


export const data = [
  {
    "category": "shoes",
    "subCategory": "casual",
    "title": "Nike Air Zoom Pegasus 39",
    "desc": "Men's Road Running Shoes",
    "price": "₹10,439",
    "imgurl": img10
  },
  {
    "category": "shoes",
    "subCategory": "casual",
    "title": "Nike Zoom Fly 5",
    "desc": "JavMen's Road Running Shoesa",
    "price": "₹14,995",
    "imgurl": img11
  },
  {
    "category": "shoes",
    "subCategory": "casual",
    "title": "Nike Zoom Superfly Elite 2",
    "desc": "Athletics Sprinting Spikes",
    "price": "₹13,995",
    "imgurl": img12
  },
  {
    "category": "shoes",
    "subCategory": "formal",
    "title": "Nike Pegasus 39",
    "desc": "Men's Road Running Shoes",
    "price": "₹10,495",
    "imgurl": img13
  },
  {
    "category": "shoes",
    "subCategory": "formal",
    "title": "Air Jordan 7 Retro SE",
    "desc": "Men's Shoes",
    "price": "₹19,295",
    "imgurl": img14
  },
  {
    "category": "shoes",
    "subCategory": "formal",
    "title": "Nike Air Force 1 Low Retro",
    "desc": "Men's Shoes",
    "price": "₹12,795",
    "imgurl": img15
  },
  {
    "category": "shoes",
    "subCategory": "sports",
    "title": "BAD BUNNY - LAST FORUM SHOES",
    "desc": "Originals",
    "price": "₹15,999",
    "imgurl": img16
  },
  {
    "category": "shoes",
    "subCategory": "sports",
    "title": "ULTRABOOST 5 DNA RUNNING SPORTSWEAR LIFESTYLE SHOES",
    "desc": "women's Sportwear",
    "price": "₹17,999",
    "imgurl": img17
  },
  {
    "category": "shoes",
    "subCategory": "sports",
    "title": "ADIDAS ADIZERO SL RUNNING SHOES",
    "desc": "Men's Running Shoes",
    "price": "₹11,999",
    "imgurl": img18
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "Gini and Jony",
    "desc": "Boys Red & Navy Blue Cotton Tartan Checks Hooded Casual Shirt",
    "price": "₹909",
    "imgurl": img19
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "KIDZ Clothing",
    "desc": "Boys Blue & Green Emroidered Pure Cotton Kurta with Dhoti Pants",
    "price": "₹1,019",
    "imgurl": img20
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "Cutiekins",
    "desc": "Boys Blue & Red Solid Sweatshirt with Joggers",
    "price": "₹839",
    "imgurl": img21
  },
  {
    "category": "kids",
    "subCategory": "pant",
    "title": "DKGF FASHION",
    "desc": "Boys Purple & Black Printed T-shirt with Jeans & Blazer",
    "price": "₹1,419",
    "imgurl": img22
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "De Moza",
    "desc": "Girls Blue & Pink Printed Top",
    "price": "₹269",
    "imgurl": img23
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "H&M",
    "desc": "Girls Pink Printed Jersey Top",
    "price": "₹1,399",
    "imgurl": img24
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "H&M",
    "desc": "Kids Boys Cotton jersey top",
    "price": "₹399",
    "imgurl": img25
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "H&M",
    "desc": "Boys White Easy-Iron Shirt",
    "price": "₹799",
    "imgurl": img26
  },
  {
    "category": "kids",
    "subCategory": "pant",
    "title": "Pepe Jeans",
    "desc": "Boys Red & Navy Blue Tartan Checks Opaque Cotton Casual Shirt",
    "price": "₹799",
    "imgurl": img27
  },
  {
    "category": "women",
    "subCategory": "shirt",
    "title": "Libas",
    "desc": "women Pink Floral Printed Panelled Pure Cotton Kurta with Palazzos & With Dupatta",
    "price": "₹1,399",
    "imgurl":img28
  },
  {
    "category": "women",
    "subCategory": "shirt",
    "title": "KALINI",
    "desc": "women Pink Floral Printed Kurta with Trousers & With Dupatta",
    "price": "₹874",
    "imgurl":img29
  },
  {
    "category": "women",
    "subCategory": "shirt",
    "title": "Shae by SASSAFRAS",
    "desc": "women Blue & Off-White Printed Anarkali Kurta",
    "price": "₹594",
    "imgurl":img30
  },
  {
    "category": "women",
    "subCategory": "pant",
    "title": "Mitera",
    "desc": "Cream-Coloured & Red Floral Silk Blend Saree",
    "price": "₹2,942",
    "imgurl":img31
  },
  { "category": "women",
    "subCategory": "pant",
    "title": "KALINI",
    "desc": "White & Gold-Toned Zari Saree", 
    "price": "₹599",
    "imgurl":img32 },
  {
    "category": "women",
    "subCategory": "pant",
    "title": "Tokyo Talkies",
    "desc": "Navy Blue Polka Dots Printed Shirt Dress",
    "price": "₹462",
    "imgurl":img33
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "KALINI",
    "desc": "Maroon & Gold Ethnic Motifs Zari Silk Blend Banarasi Saree",
    "price": "₹587",
    "imgurl":img34
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "Rose Sleeveless",
    "desc": "Coral red activewear tank top with slub effect.",
    "price": "₹249",
    "imgurl":img35
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "SASSAFRAS",
    "desc": "Rose Self Design Dobby Weave Wrap Dress & Belt",
    "price": "₹469",
    "imgurl":img36
  },
  {
    "category": "men",
    "subCategory": "shirt",
    "title": "Manyavar",
    "desc": "Men White & Blue Floral Print Nehru Jacket",
    "price": "₹2,999",
    "imgurl": img1
  },
  {
    "category": "men",
    "subCategory": "shirt",
    "title": "Anouk",
    "desc": "Men White & Navy Blue Self Striped Straight Kurta",
    "price": "₹479",
    "imgurl": img2
  },
  {
    "category": "men",
    "subCategory": "shirt",
    "title": "Manyavar",
    "desc": "Men Blue Ethnic Motifs Woven Design Kurta with Churidar",
    "price": "₹3,999",
    "imgurl": img3
  },
  {
    "category": "men",
    "subCategory": "tshirt",
    "title": "Anouk",
    "desc": "Men Grey & White Solid Pure Cotton Kurta with Salwar & Printed Jacked",
    "price": "₹1,319",
    "imgurl": img4
  },
  {
    "category": "men",
    "subCategory": "tshirt",
    "title": "Roadster",
    "desc": "Men Maroon & Black Checked Pure Cotton Sustainable Casual Shirt",
    "price": "₹649",
    "imgurl": img5
  },
  {
    "category": "men",
    "subCategory": "tshirt",
    "title": "HIGHLANDER",
    "desc": "Men Green & White Slim Fit Printed Casual Shirt",
    "price": "₹367",
    "imgurl": img6
  },
  {
    "category": "men",
    "subCategory": "pant",
    "title": "Dennis Lingo",
    "desc": "Men Blue Slim Fit Windowpane Checked Casual Shirt",
    "price": "₹749",
    "imgurl": img7
  },
  {
    "category": "men",
    "subCategory": "pant",
    "title": "Roadster",
    "desc": "Men Blue Denim Washed Casual Sustainable Shirt",
    "price": "₹899",
    "imgurl": img8
  },
  {
    "category": "men",
    "subCategory": "pant",
    "title": "HERE&NOW",
    "desc": "Men Black Slim Fit Printed Casual Shirt",
    "price": "₹664",
    "imgurl": img9
  },
  {
    "category": "men",
    "subCategory": "pant",
    "title": "HRX by Hrithik Roshan",
    "desc": "Men Maroon Solid Hooded Sweatshirt",
    "price": "₹1199",
    "imgurl": img37
  },
  {
    "category": "men",
    "subCategory": "pant",
    "title": "English Navy",
    "desc": "Men Black Slim Fit Formal Shirt",
    "price": "₹499",
    "imgurl": img38
  },
  {
    "category": "men",
    "subCategory": "pant",
    "title": "Blackberrys",
    "desc": "Men Maroon Pure Cotton Slim Fit Formal Shirt",
    "price": "₹1,317",
    "imgurl": img39
  },
  {
    "category": "men",
    "subCategory": "shirt",
    "title": "Louis Philippe",
    "desc": "Men White Self Design Classic Pure Cotton Formal Shirt",
    "price": "₹1679",
    "imgurl": img40
  },
  {
    "category": "men",
    "subCategory": "shirt",
    "title": "HRX by Hrithik Roshan",
    "desc": "Men Teal Blue Printed Pure Cotton T-shirt",
    "price": "₹419",
    "imgurl": img41
  },
  {
    "category": "men",
    "subCategory": "shirt",
    "title": "Roadster",
    "desc": "Men Charcoal Melange Graphic Printed T-shirt",
    "price": "₹349",
    "imgurl": img42
  },
  {
    "category": "men",
    "subCategory": "tshirt",
    "title": "Roadster",
    "desc": "Men Grey All-Over-Printed Round Neck T-shirt",
    "price": "₹449",
    "imgurl": img43
  },
  {
    "category": "men",
    "subCategory": "tshirt",
    "title": "Kook N Keech",
    "desc": "Men Black Solid Hooded Sweatshirt",
    "price": "₹699",
    "imgurl": img44
  },
  {
    "category": "men",
    "subCategory": "tshirt",
    "title": "Roadster",
    "desc": "Men Grey & Navy Blue Striped Sweatshirt",
    "price": "₹559",
    "imgurl": img45
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "Rustorange",
    "desc": "Black & Orange Ethnic Motifs Printed Maxi Dress",
    "price": "₹2,649",
    "imgurl": img65
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "Antheaa",
    "desc": "women White Self-Design Tiered A-Line Dress",
    "price": "₹2,399",
    "imgurl": img66
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "Berrylush",
    "desc": "women Gorgeous Red Floral Ruched Dress",
    "price": "₹1,299",
    "imgurl": img67
  },
  {
    "category": "women",
    "subCategory": "pant",
    "title": "Anouk",
    "desc": "women Mustard Yellow Yoke Design Foil Printed Kurta with Trousers & Dupatta",
    "price": "₹1,879",
    "imgurl": img68
  },
  {
    "category": "women",
    "subCategory": "pant",
    "title": "FASHOR",
    "desc": "Floral Printed Kurta with Trousers & With Dupatta",
    "price": "₹4,199",
    "imgurl": img69
  },
  {
    "category": "women",
    "subCategory": "pant",
    "title": "KALINI",
    "desc": "women Green Ethnic Motifs Embroidered Thread Work Kurta with Palazzo & Dupatta",
    "price": "₹3,699",
    "imgurl": img70
  },
  {
    "category": "women",
    "subCategory": "shirt",
    "title": "The Souled Store",
    "desc": "women Cotton Printed Loose T-shirt",
    "price": "₹899",
    "imgurl": img71
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "DILLINGER",
    "desc": "Sage Green Graphic Printed Pure Cotton Oversized Pure Cotton T-shirt",
    "price": "₹1,399",
    "imgurl": img72
  },
  {
    "category": "women",
    "subCategory": "tshirt",
    "title": "DILLINGER",
    "desc": "women Purple Typography Printed Drop-Shoulder Sleeves Oversized Pure Cotton T-shirt",
    "price": "₹515",
    "imgurl": img73
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "Nautica",
    "desc": "Boys Maroon Brand Logo Print Round Neck Pure Cotton T-shirt",
    "price": "₹599",
    "imgurl": img46
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "Nautica",
    "desc": "Boys Red Brand Logo Print Round Neck Pure Cotton T-shirt",
    "price": "₹649",
    "imgurl": img47
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "Sangria",
    "desc": "Girls Red & Green Ethnic Motifs Print Pure Cotton A-Line Top",
    "price": "₹749",
    "imgurl": img48
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "H&M",
    "desc": "Girls Green & Purple Puff Sleeved Jersey Top",
    "price": "₹419",
    "imgurl": img49
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "VASTRAMAY",
    "desc": "Boys Beige & Rose Gold-Coloured Woven Design Sherwani Set",
    "price": "₹3,299",
    "imgurl": img50
  },
  {
    "category": "kids",
    "subCategory": "skirt",
    "title": "Cutiekins",
    "desc": "Girls Red & Gold-Toned Sequinned Ready to Wear Lehenga & Blouse With Dupatta",
    "price": "₹1,769",
    "imgurl": img51
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "Nautica",
    "desc": "Boys Navy Blue & White Brand Logo Print Embroidered Pure Cotton T-shirt",
    "price": "₹599",
    "imgurl": img52
  },
  {
    "category": "kids",
    "subCategory": "skirt",
    "title": "pspeaches",
    "desc": "Girls Blue & Pink Ready to Wear Lehenga & Blouse With Dupatta",
    "price": "₹1,370",
    "imgurl": img53
  },
  {
    "category": "kids",
    "subCategory": "tshirt",
    "title": "Cutiekins",
    "desc": "Girls Multicoloured Printed Top",
    "price": "₹484",
    "imgurl": img54
  },
  {
    "category": "women",
    "subCategory": "shirt",
    "title": "URBAN STUDIO Swim Suit ",
    "desc": "Full sleeve, ladies, anti-pervert swim suit",
    "price": "₹484",
    "imgurl": img75
  },
  {
    "category": "women",
    "subCategory": "shirt",
    "title": "Full wear Swim Suit ",
    "desc": "Black, shiney, soft, long sleeve ladies non-pervert swim suit",
    "price": "₹484",
    "imgurl": img76
  },
  {
    "category": "electronics",
    "subCategory": "",
    "title": "MacBook Pro 13”",
    "desc": "The 13-inch MacBook Pro is supercharged by M2.",
    "price": "122000",
    "imgurl": img74
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "School Uniform Boys",
    "desc": "KIRONIKNIT School Uniform Full Sleeves Sweater - Daffodil ",
    "price": "₹459",
    "imgurl": img77
  },
  {
    "category": "kids",
    "subCategory": "shirt",
    "title": "School Uniform Girls",
    "desc": "Children Welfare Girls Primary Uniform",
    "price": "₹580",
    "imgurl": img78
  },
  {
    "category": "shoes",
    "subCategory": "formal",
    "title": "Wildcraft men swish",
    "desc": "Mens Swift Outdoor Open Toe Sandals",
    "price": "₹449",
    "imgurl": img79
  },
]


